import React from "react";
import { GoArrowUpRight } from "react-icons/go";
import { useInView } from "react-intersection-observer";
import { NavLink } from "react-router-dom";

const PrivateSocietyCard = ({ cd }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <NavLink
      to={`${cd.link}`}
      ref={ref}
      className={` custom-div flex flex-col xl:w-[20rem] sm:w-[18rem]  w-[90%] sm:mx-a mx-auto p-4 rounded-2xl group ${
        inView ? `lg:animate-slideUp ${cd.class}` : "opacity-0"
      } `}
      // style={{ backgroundColor: cd?.bgColor }}
      style={{ "--bg-color": cd?.bgColor, "--hover-color": cd?.tagColor }}
    >
      <div className="w-full relative">
        <img src={cd?.image} className="rounded-xl" alt={cd?.name} />
        <span
          className="absolute top-2 left-2 flex items-center gap-2 text-white font-medium py-1 px-2 rounded-lg"
          style={{ backgroundColor: cd?.tagColor }}
        >
          <span className="p-[2px] size-5 rounded-md bg-white">
            {React.cloneElement(cd?.icon, {
              className: "size-4",
              style: { color: cd?.tagColor },
            })}
          </span>
          {cd?.tagName}
        </span>
      </div>

      <div className="flex justify-between items-center pt-4 text-[1rem] font-semibold">
        {cd?.name}

        <NavLink
          to={`${cd.link}`}
          className="relative group"
          style={{
            "--tag-color": cd?.tagColor,
          }}
        >
          <GoArrowUpRight
            className="size-8 p-1 rounded-full cursor-pointer font-bold text-white transition-all duration-300 
      bg-[var(--tag-color)] group-hover:bg-white group-hover:text-[var(--tag-color)]"
          />
        </NavLink>
      </div>
    </NavLink>
  );
};

export default PrivateSocietyCard;
